const restoreItem = async (updateItem: any, dataObservationGrid: any) => {
  const observationGrid = { ...dataObservationGrid };
  try {
    if (observationGrid.id) {
      await updateItem(observationGrid.id, {
        park: observationGrid.park,
        isArchived: !observationGrid.isArchived,
      });
    }
  } catch (e: any) {
    return e;
  }
  return true;
};

export default restoreItem;
